export const FETCH_USB_CERTIFICATES_DATA = 'FETCH_USB_CERTIFICATES_DATA'
export const SET_LOADER = 'SET_LOADER'
export const SET_USB_CERTIFICATES_LIST_TABLE_PROPS = 'SET_USER_LIST_TABLE_PROPS'
export const CLEAR_USB_CERTIFICATES_LIST_DATA = 'CLEAR_USER_LIST_DATA'
export const FETCH_CHARGER_CERTIFICATES_INFO_DATA = 'FETCH_CHARGER_CERTIFICATES_INFO_DATA'
export const SET_CHARGER_CERTIFICATES_INFO_LIST_TABLE_PROPS = 'SET_CHARGER_CERTIFICATES_INFO_LIST_TABLE_PROPS'
export const CLEAR_CHARGER_CERTIFICATES_INFO_LIST_DATA = 'CLEAR_CHARGER_CERTIFICATES_INFO_LIST_DATA'